"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupSelection = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const surface_1 = require("../../../../../../surface");
const withInlineValidation_1 = __importDefault(require("../../../../../wrappers/withInlineValidation"));
const links_1 = require("../../../../../utils/links");
const workflowContext_1 = require("../../../../../utils/workflowContext");
const GroupSelection = ({ id, onChange, value = '', disabled = false, invalid = false, formContext, schema }) => {
    // check if the widget is locked because of forms links
    const isLocked = links_1.isLockedWidget(id, formContext.links);
    const inputOptions = react_1.useMemo(() => {
        // get selectable options from the form's workflowContext
        const groups = workflowContext_1.buildSelectableGroupsList(formContext.workflowContext, schema.formatOptions);
        return groups.map(({ label, name, avatar }) => ({
            value: label,
            label: name,
            prefix: jsx_runtime_1.jsx(surface_1.AvatarGroup, { src: avatar, size: 22 }, void 0)
        }));
    }, [formContext.workflowContext, schema.formatOptions]);
    return (jsx_runtime_1.jsx(surface_1.SmartDropdown, { id: id, options: inputOptions, value: value, onSelect: onChange, label: schema.title, disabled: disabled || isLocked, invalid: invalid, shadows: true }, void 0));
};
exports.GroupSelection = GroupSelection;
exports.default = withInlineValidation_1.default(react_1.memo(exports.GroupSelection));
//# sourceMappingURL=index.js.map